__turbopack_context__.v({
  "actions": "CartDrawer-module__tlybHq__actions",
  "content": "CartDrawer-module__tlybHq__content",
  "drawer": "CartDrawer-module__tlybHq__drawer",
  "header": "CartDrawer-module__tlybHq__header",
  "imgWrap": "CartDrawer-module__tlybHq__imgWrap",
  "inventoryModal": "CartDrawer-module__tlybHq__inventoryModal",
  "inventoryModalOverlay": "CartDrawer-module__tlybHq__inventoryModalOverlay",
  "productImg": "CartDrawer-module__tlybHq__productImg",
  "removedProductItem": "CartDrawer-module__tlybHq__removedProductItem",
  "removedProductList": "CartDrawer-module__tlybHq__removedProductList",
});
